(function(){
  if (window.__nelora) return; window.__nelora = true;
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('nl-js');
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }) : null;
  function scan(scope){
    (scope || document).querySelectorAll('[data-nl-reveal]:not(.is-in)').forEach(function(el){
      if (!io || reduce || (window.Shopify && Shopify.designMode)) { el.classList.add('is-in'); } else { io.observe(el); }
    });
    (scope || document).querySelectorAll('[data-nl-stagger]').forEach(function(group){
      var step = parseFloat(group.getAttribute('data-nl-stagger')) || 0.12;
      Array.prototype.forEach.call(group.children, function(c, i){ c.style.setProperty('--nl-delay', (i * step) + 's'); });
    });
    (scope || document).querySelectorAll('[data-nl-qty]').forEach(function(w){
      if (w.__nl) return; w.__nl = true;
      var input = w.querySelector('input');
      w.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click', function(){
          var v = parseInt(input.value, 10) || 1;
          v = b.getAttribute('data-step') === '-' ? Math.max(1, v - 1) : v + 1;
          input.value = v;
        });
      });
    });
  }
  var par = [];
  function collectPar(){ par = Array.prototype.slice.call(document.querySelectorAll('.nl-parallax img')); }
  function onScroll(){
    if (reduce) return;
    var vh = window.innerHeight;
    par.forEach(function(img){
      var r = img.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      img.style.transform = 'translate3d(0,' + (p * -60).toFixed(1) + 'px,0) scale(1.12)';
    });
  }
  function init(){ scan(); collectPar(); onScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('scroll', function(){ window.requestAnimationFrame(onScroll); }, { passive: true });
  document.addEventListener('shopify:section:load', function(e){ scan(e.target); collectPar(); onScroll(); });
})();
